import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { LabelsDataService } from '../../../services/labels-data.service';
import { SubscriptionHandler } from '../../components/subscriptionHandler';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { NirFormControl } from './nir-form-control';

@Component({
  standalone: false,
  selector: 'app-nir-form-control',
  templateUrl: './nir-form-control.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NirFormControlComponent),
      multi: true
    }
  ]
})
export class NirFormControlComponent
  extends AbstractFormControlComponent<NirFormControl>
  implements OnInit, ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  @Output() onChanged: EventEmitter<any> = new EventEmitter();

  faCheck: any = faCheck;
  subscriptionHandler: SubscriptionHandler = new SubscriptionHandler();
  requiredText: string = '';

  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  change(): void {
    this.onChanged.emit(this.control.value);
  }

  constructor(public labelsDataService: LabelsDataService) {
    super();
  }

  ngOnInit(): void {
    this.requiredText = this.labelsDataService.getData(
      'COMMON.PleaseFillInThisFieldText'
    );
  }

  public get hideSuccessMark(): boolean {
    return this.control.hideSuccessMark || false;
  }
}
